<!-- suppress ES6UnusedImports -->
<script lang="ts">
import { createOrUpdate as createOrUpdateExtent, getCenter as getExtendCenter } from 'ol/extent.js'
import Map from 'ol/Map'
import Zoom from 'ol/control/Zoom'

export default {
    name: 'DkOlMap',
    components: { },
    props: {
        bbox: {
            type: { x_min: Number, x_max: Number, y_min: Number, y_max: Number },
            required: true,
        },
        projection: { required: false, default: 'EPSG:3857' },
        height: { type: String, required: false, default: '' }, // Need to be with px, rem etc..
        zoomInTipLabel: { type: String, required: false, default: 'Zoomer' },
        zoomOutTipLabel: { type: String, required: false, default: 'Dézoomer' },
    },
    data() {
        return {
            drawer: false,
        }
    },
    computed: {
        bboxExtent() {
            return createOrUpdateExtent(this.bbox.x_min, this.bbox.y_min, this.bbox.x_max, this.bbox.y_max)
        },
        center() {
            return getExtendCenter(this.bboxExtent)
        },
        map(): Map {
            return this.$refs.map.map
        },
    },
    mounted() {
        // zoom on extend
        this.fitBbox()
        this.updateZoomLabel()
    },
    methods: {
        fitBbox(duration: number = 0): void {
            const mapComponent = this.$refs.map
            mapComponent.map.getView().fit(this.bboxExtent, { duration })
        },
        updateZoomLabel(): void {
            const map = this.map;
            // remove default zoom
            map.getControls().getArray()
                .filter(control => control instanceof Zoom)
                .forEach(control => map.removeControl(control));

            map.addControl(new Zoom({
                zoomInTipLabel: this.zoomInTipLabel,
                zoomOutTipLabel: this.zoomOutTipLabel,
            }));
        },
    },
}
</script>

<template>
    <v-layout id="fullscreen datakode-map" class="fullscreen" :style="{ height: height ? height : 'auto' }">
        <ol-map ref="map" class="datakode-ol-map" :style="{ height: height ? height : 'auto', aspectRatio : '31 / 17', width: '100%' }">
            <ol-view :center :zoom="9" :projection />

            <!--            <ol-attribution-control /> -->
            <slot />
        </ol-map>
    </v-layout>
</template>

<style>
.ol-map:has(.ol-full-screen .ol-full-screen-true) {
    height: 100% !important;
}

.ol-attribution.ol-control {
    background-color: white!important;
}
</style>
